import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const StickyButtons = () => {
  return (
    <div className="fixed bottom-6 right-6 flex flex-col space-y-4 z-50 md:hidden">
      <a
        href="tel:8936835037"
        className="bg-dark-green text-white p-4 rounded-full shadow-2xl hover:bg-dark-green-deep transition-all transform hover:scale-110 active:scale-95 flex items-center justify-center"
        aria-label="Call Now"
      >
        <Phone size={24} />
      </a>
      <a
        href="https://wa.me/918936835037"
        className="bg-green-whatsapp text-white p-4 rounded-full shadow-2xl hover:opacity-90 transition-all transform hover:scale-110 active:scale-95 flex items-center justify-center"
        aria-label="WhatsApp Us"
      >
        <MessageCircle size={24} />
      </a>
    </div>
  );
};

export default StickyButtons;
